import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import React, { createContext, useContext } from 'react';
export var PluginOptions = createContext();
var Provider = PluginOptions.Provider;
export { Provider };
export var usePluginOptions = function usePluginOptions() {
  return useContext(PluginOptions);
};
export var withPluginOptions = function withPluginOptions(Comp) {
  return function (props) {
    return React.createElement(PluginOptions.Consumer, null, function (options) {
      return React.createElement(Comp, Object.assign({}, props, {
        pluginOptions: options
      }));
    });
  };
};